import { create } from "zustand";
import type { User } from "@/types/api";

interface AuthState {
  user: User | null;
  accessToken: string | null;
  setAuth: (user: User | null, token: string | null) => void;
  setToken: (token: string | null) => void;
  setUser: (user: User | null) => void;
  clear: () => void;
}

// Token lives in memory only — never persisted. A page reload triggers a silent
// refresh via the httponly cookie (matches fleet-tracker).
export const useAuthStore = create<AuthState>((set) => ({
  user: null,
  accessToken: null,
  setAuth: (user, token) => set({ user, accessToken: token }),
  setToken: (token) => set({ accessToken: token }),
  setUser: (user) => set({ user }),
  clear: () => set({ user: null, accessToken: null }),
}));
